(function () {
  if (window.UrbanFeefoLoaded) { return; }
  window.UrbanFeefoLoaded = true;

  var API = 'https://api.feefo.com/api/20';
  var STAR = 'M8 1.2l2.06 4.3 4.69.63-3.42 3.28.86 4.7L8 11.87 3.81 14.1l.86-4.7L1.25 6.13l4.69-.63z';
  var TAG = '[urban-feefo]';
  var summaryPromise = null;

  function enc(v) { return encodeURIComponent(v); }

  function skuParam(refs) {
    return refs.map(function (r) { return enc(r); }).join(',');
  }

  function get(url) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 9000);
    return fetch(url, { signal: ctrl.signal, credentials: 'omit' }).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) {
        return r.text().then(function (body) {
          console.warn(TAG, 'HTTP ' + r.status, url, body.slice(0, 300));
          throw new Error('feefo ' + r.status);
        });
      }
      return r.json();
    });
  }

  function summary(merchant) {
    if (!summaryPromise) {
      summaryPromise = get(API + '/reviews/summary/all?merchant_identifier=' + enc(merchant) + '&since_period=all');
    }
    return summaryPromise;
  }

  function rounded(n) {
    return n >= 5 ? (Math.floor((n - 1) / 5) * 5) + '+' : String(n);
  }

  function stars(value) {
    var v = Math.max(0, Math.min(5, Number(value) || 0));
    var uid = 'uf' + Math.random().toString(36).slice(2, 8);
    var out = '';
    for (var i = 0; i < 5; i++) {
      var w = Math.max(0, Math.min(1, v - i)) * 16;
      out += '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
        + '<path class="uf-star-bg" d="' + STAR + '"/>'
        + '<clipPath id="' + uid + i + '"><rect x="0" y="0" width="' + w + '" height="16"/></clipPath>'
        + '<path class="uf-star-fg" clip-path="url(#' + uid + i + ')" d="' + STAR + '"/>'
        + '</svg>';
    }
    return '<span class="uf-stars" role="img" aria-label="' + v.toFixed(1) + ' out of 5">' + out + '</span>';
  }

  function fmtDate(ms) {
    try {
      return new Date(ms).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch (e) { return ''; }
  }

  function refsFor(el) {
    var a = el.getAttribute('data-ref');
    var b = el.getAttribute('data-sku');
    if (!a && window.UFProduct) { a = window.UFProduct.id; b = window.UFProduct.sku; }
    var out = [];
    [a, b].forEach(function (v) {
      if (v && String(v).length && out.indexOf(String(v)) === -1) { out.push(String(v)); }
    });
    return out;
  }

  function initAnn(el) {
    var merchant = el.getAttribute('data-merchant') || 'urban-automotive';
    var rotator = el.parentNode;
    while (rotator && !(rotator.getAttribute && rotator.getAttribute('data-uf-ann-rotator') !== null && rotator.hasAttribute('data-uf-ann-rotator'))) {
      rotator = rotator.parentNode;
    }
    if (!rotator) { return; }

    summary(merchant).then(function (data) {
      var rating = data && data.rating ? Number(data.rating.rating) : 0;
      var count = data && data.rating && data.rating.service ? Number(data.rating.service.count) : 0;
      if (!rating) { return; }

      el.querySelector('[data-uf-ann-score]').textContent = rating.toFixed(1) + ' / 5';
      el.querySelector('[data-uf-ann-stars]').innerHTML = stars(rating);
      el.querySelector('[data-uf-ann-text]').textContent =
        (el.getAttribute('data-text') || '[rounded] verified reviews')
          .replace('[rounded]', rounded(count))
          .replace('[count]', String(count));

      var alt = true;
      rotator.classList.add('uf-is-alt');

      setInterval(function () {
        if (document.hidden) { return; }
        alt = !alt;
        rotator.classList.toggle('uf-is-alt', alt);
      }, 6000);
    }).catch(function (e) { console.warn(TAG, 'announcement failed', e.message); });
  }

  function initBand(el) {
    var merchant = el.getAttribute('data-merchant') || 'urban-automotive';
    summary(merchant)
      .then(function (data) {
        var rating = data && data.rating ? Number(data.rating.rating) : 0;
        var count = data && data.rating && data.rating.service ? Number(data.rating.service.count) : 0;
        var url = data && data.merchant ? data.merchant.review_url : null;
        if (!rating) { return; }

        el.querySelector('[data-uf-score]').innerHTML = rating.toFixed(1) + ' <span>/ 5</span>';
        el.querySelector('[data-uf-stars]').innerHTML = stars(rating);

        var tpl = el.getAttribute('data-text') || '';
        el.querySelector('[data-uf-text]').textContent = tpl
          .replace('[count]', String(count))
          .replace('[rounded]', rounded(count));

        var link = el.querySelector('[data-uf-link]');
        if (link) {
          if (url) { link.href = url; } else { link.parentNode.removeChild(link); }
        }
        el.classList.add('is-ready');
      })
      .catch(function (e) { console.warn(TAG, 'band failed', e.message); });
  }

  function initRating(el) {
    var merchant = el.getAttribute('data-merchant') || 'urban-automotive';
    var refs = refsFor(el);
    if (!refs.length) { console.warn(TAG, 'rating: no product refs'); return; }

    get(API + '/products/ratings?merchant_identifier=' + enc(merchant)
        + '&review_count=true&since_period=all&product_sku=' + skuParam(refs))
      .then(function (data) {
        var list = (data && data.products) || [];
        var total = 0, weighted = 0;
        list.forEach(function (p) {
          var c = Number(p.review_count || p.reviews_count || 0) || 0;
          var r = Number(p.rating) || 0;
          if (!c || !r) { return; }
          total += c;
          weighted += r * c;
        });
        if (!total) { return; }

        var avg = weighted / total;
        el.querySelector('[data-uf-stars]').innerHTML = stars(avg);
        el.querySelector('[data-uf-score]').textContent = avg.toFixed(1) + ' / 5';
        el.querySelector('[data-uf-count]').textContent = total + (total === 1 ? ' verified review' : ' verified reviews');
        el.classList.add('is-ready');
      })
      .catch(function (e) { console.warn(TAG, 'rating failed', e.message); });
  }

  function reviewCard(entry, item) {
    var wrap = document.createElement('article');
    wrap.className = 'uf-review';

    var top = document.createElement('div');
    top.className = 'uf-review__top';
    top.innerHTML = stars(item.rating && item.rating.rating);

    var name = document.createElement('span');
    name.className = 'uf-review__name';
    name.textContent = (entry.customer && entry.customer.display_name) || 'Verified customer';
    top.appendChild(name);

    var badge = document.createElement('span');
    badge.className = 'uf-review__badge';
    badge.textContent = 'Verified purchase';
    top.appendChild(badge);

    if (item.created_at) {
      var when = document.createElement('span');
      when.className = 'uf-review__date';
      when.textContent = fmtDate(item.created_at);
      top.appendChild(when);
    }
    wrap.appendChild(top);

    if (item.review) {
      var body = document.createElement('p');
      body.className = 'uf-review__body';
      body.textContent = item.review;
      wrap.appendChild(body);
    }

    (item.thread || []).forEach(function (t) {
      if (t.type !== 'merchant_comment' || !t.comment) { return; }
      var reply = document.createElement('p');
      reply.className = 'uf-review__reply';
      reply.textContent = 'House of Urban: ' + t.comment;
      wrap.appendChild(reply);
    });

    return wrap;
  }

  function initReviews(el) {
    var merchant = el.getAttribute('data-merchant') || 'urban-automotive';
    var refs = refsFor(el);
    if (!refs.length) { console.warn(TAG, 'reviews: no product refs'); return; }

    var list = el.querySelector('[data-uf-list]');
    var more = el.querySelector('[data-uf-more]');
    var allLink = el.querySelector('[data-uf-all]');
    var meta = el.querySelector('[data-uf-meta]');
    var page = 0;
    var busy = false;

    function url(mode, p) {
      var u = API + '/reviews/' + mode + '?merchant_identifier=' + enc(merchant)
        + '&product_sku=' + skuParam(refs) + '&since_period=all';
      if (p > 1) { u += '&page=' + p; }
      return u;
    }

    function render(data, p) {
      var entries = (data && data.reviews) || [];
      var m = (data && data.summary && data.summary.meta) || {};
      var rows = [];
      var feefoUrl = null;

      entries.forEach(function (entry) {
        (entry.products || []).forEach(function (item) {
          var sku = item.product && (item.product.sku || item.product.parent_sku);
          if (refs.indexOf(String(sku)) === -1) { return; }
          if (item.product && item.product.reviews_url) { feefoUrl = item.product.reviews_url; }
          rows.push({ entry: entry, item: item, at: Number(item.created_at) || 0 });
        });
      });

      if (p === 1 && !rows.length) { return false; }

      rows.sort(function (a, b) { return b.at - a.at; });
      rows.forEach(function (row) { list.appendChild(reviewCard(row.entry, row.item)); });

      if (p === 1) {
        var total = Number(m.count) || rows.length;
        meta.textContent = total + (total === 1 ? ' verified review' : ' verified reviews');
        if (feefoUrl && allLink) { allLink.href = feefoUrl; allLink.hidden = false; }
        el.classList.add('is-ready');
      }

      page = p;
      if (more) { more.hidden = !(Number(m.pages) > p); }
      return true;
    }

    function load(p) {
      if (busy) { return; }
      busy = true;
      get(url('product', p))
        .then(function (data) {
          if (render(data, p) === false && p === 1) {
            return get(url('all', p)).then(function (d2) { render(d2, p); });
          }
        })
        .catch(function () {
          return get(url('all', p)).then(function (d2) { render(d2, p); })
            .catch(function (e) { console.warn(TAG, 'reviews failed', e.message); });
        })
        .then(function () { busy = false; });
    }

    if (more) {
      more.addEventListener('click', function () { load(page + 1); });
    }
    load(1);
  }

  function serviceCard(entry) {
    var s = entry.service || {};
    var card = document.createElement('article');
    card.className = 'uf-service__card';

    var st = document.createElement('div');
    st.className = 'uf-service__stars';
    st.innerHTML = stars(s.rating && s.rating.rating);
    card.appendChild(st);

    if (s.title) {
      var quote = document.createElement('p');
      quote.className = 'uf-service__quote';
      quote.textContent = s.title;
      card.appendChild(quote);
    }

    if (s.review) {
      var body = document.createElement('p');
      body.className = 'uf-service__body';
      body.textContent = s.review;
      card.appendChild(body);
    }

    var who = (entry.customer && entry.customer.display_name) || 'Verified customer';
    var meta = document.createElement('p');
    meta.className = 'uf-service__meta';
    meta.textContent = who + ' \u00b7 Feefo verified' + (s.created_at ? ' \u00b7 ' + fmtDate(s.created_at) : '');
    card.appendChild(meta);

    return card;
  }

  function initService(el) {
    var merchant = el.getAttribute('data-merchant') || 'urban-automotive';
    var count = parseInt(el.getAttribute('data-count'), 10) || 3;
    var pinnedRaw = el.getAttribute('data-pinned') || '';
    var pinned = pinnedRaw.split('|').map(function (s) {
      return s.trim().toLowerCase();
    }).filter(function (s) { return s.length > 0; });

    var grid = el.querySelector('[data-uf-grid]');
    var meta = el.querySelector('[data-uf-meta]');

    function url(mode) {
      return API + '/reviews/' + mode + '?merchant_identifier=' + enc(merchant)
        + '&since_period=all&page_size=100&page=1';
    }

    function usable(data) {
      var entries = (data && data.reviews) || [];
      var m = (data && data.summary && data.summary.meta) || {};
      var rows = entries.filter(function (entry) {
        var s = entry.service;
        return s && (s.review || s.title);
      });
      return { rows: rows, total: Number(m.count) || rows.length };
    }

    function paint(res) {
      var rows = res.rows;
      if (!rows.length) { console.warn(TAG, 'service: no usable reviews'); return; }

      var picked = [];
      pinned.forEach(function (want) {
        for (var i = 0; i < rows.length; i++) {
          var t = (rows[i].service.title || '').trim().toLowerCase();
          if (t === want && picked.indexOf(rows[i]) === -1) { picked.push(rows[i]); break; }
        }
      });

      var rest = rows.filter(function (r) { return picked.indexOf(r) === -1; });
      rest.sort(function (a, b) {
        return (Number(b.service.created_at) || 0) - (Number(a.service.created_at) || 0);
      });

      picked.concat(rest).slice(0, count).forEach(function (entry) {
        grid.appendChild(serviceCard(entry));
      });

      if (meta) {
        meta.textContent = rounded(res.total) + ' verified reviews, independently collected by Feefo';
      }
      el.classList.add('is-ready');
    }

    get(url('service'))
      .then(function (data) {
        var res = usable(data);
        if (!res.rows.length) {
          return get(url('all')).then(function (d2) { paint(usable(d2)); });
        }
        paint(res);
      })
      .catch(function () {
        return get(url('all')).then(function (d2) { paint(usable(d2)); })
          .catch(function (e) { console.warn(TAG, 'service failed', e.message); });
      });
  }

  function boot(scope) {
    var root = scope || document;
    var map = [
      ['[data-uf-ann]', initAnn],
      ['[data-uf-band]', initBand],
      ['[data-uf-prating]', initRating],
      ['[data-uf-reviews]', initReviews],
      ['[data-uf-service]', initService]
    ];
    map.forEach(function (pair) {
      Array.prototype.forEach.call(root.querySelectorAll(pair[0]), function (el) {
        if (el.getAttribute('data-uf-init')) { return; }
        el.setAttribute('data-uf-init', '1');
        pair[1](el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
